
import WHighchartsStockChart from './w-highcharts-stock-chart'

const chartStyle = {
  fontFamily: 'var(--font-family-body)',
}

export default {
  components: {
    WHighchartsStockChart,
  },
  props: {
    series: {
      type: Array,
      default: () => [],
    },
    hideLegend: {
      type: Boolean,
      default: false,
    },
    hideNavigator: {
      type: Boolean,
      default: false,
    },
    hideTooltip: {
      type: Boolean,
      default: false,
    },
    legendItemDistance: {
      type: Number,
      default: 20,
    },
    yLabel: {
      type: String,
      default: null,
    },
    xFormatter: {
      type: [String, Function],
      default: null,
    },
    yFormatter: {
      type: String,
      default: 'number',
    },
    yAxisPosition: {
      type: String,
      default: 'right',
    },
    ySpacing: {
      type: Number,
      default: 45,
    },
    blurValues: {
      type: Boolean,
      default: false,
    },
    showGradient: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    yFormatterFunction() {
      return this.$getFormatterByType(this.yFormatter)
    },

    xFormatterFunction() {
      return typeof this.xFormatter === 'function'
        ? this.xFormatter
        : this.$getFormatterByType(this.xFormatter)
    },

    chartOptions() {
      const yFormatter = this.yFormatterFunction
      const yLabel = this.yLabel
      const xFormatter = this.xFormatterFunction
      const seriesLength = this.series.length
      const lineColors = [
        'var(--swi-bg-brand)',
        'var(--color-scottish-blue-1)',
        'var(--color-orange-4)',
        'var(--color-silver-3)',
        'var(--color-dark-sky-2)',
        'var(--color-dawn-4)',
        'var(--color-red-4)',
      ]

      return {
        credits: {
          enabled: false,
        },

        colors: lineColors,

        series: this.series,

        scrollbar: {
          enabled: false,
        },

        rangeSelector: {
          enabled: false,
        },

        legend: {
          enabled: !this.hideLegend,
          itemDistance: this.legendItemDistance,
        },

        chart: {
          style: chartStyle,
          backgroundColor: 'transparent',
        },

        yAxis: [
          {
            labels: {
              enabled: !this.blurValues,
              formatter() {
                return yFormatter(this.value)
              },
              style: {
                color: 'var(--swi-body-text-color-primary)',
              },
            },
            lineColor: 'var(--color-silver-screen-1)',
            gridLineColor: 'var(--color-silver-screen-1)',
            tickColor: 'var(--color-silver-screen-1)',
            opposite: this.yAxisPosition === 'right',
          },
          {
            labels: {
              enabled: !this.blurValues,
              formatter() {
                return yFormatter(this.value)
              },
              style: {
                color: 'var(--swi-body-text-color-primary)',
              },
            },
            lineColor: 'var(--color-silver-screen-1)',
            gridLineColor: 'var(--color-silver-screen-1)',
            tickColor: 'var(--color-silver-screen-1)',
            opposite: this.yAxisPosition === 'left',
          },
        ],

        xAxis: {
          labels: {
            formatter: this.xFormatter
              ? (point) => xFormatter(point.value)
              : undefined,
            style: {
              color: 'var(--swi-body-text-color-primary)',
            },
          },
          lineColor: 'var(--color-silver-screen-1)',
          gridLineColor: 'var(--color-silver-screen-1)',
          tickColor: 'var(--color-silver-screen-1)',
        },

        tooltip: {
          enabled: !(this.blurValues || this.hideTooltip),
          formatter() {
            const serie =
              (Array.isArray(this.points)
                ? this.points[0]?.series
                : this?.series) || {}

            const yWithText = `${yLabel}: ${yFormatter(this.y)}`
            const yWithoutText = yFormatter(this.y)

            // Array of tooltips needs to be equal to amount of series
            // So we need to do this hack to prevent the tooltip from showing
            // Strange behavior
            return [
              `<h3 style="font-weight: bold;">${serie.name}</h3><br /><span>${
                typeof xFormatter === 'function' ? xFormatter(this.x) : this.x
              }</span><br /><span>${
                yLabel !== undefined ? yWithText : yWithoutText
              }</span>`,
              ...[...Array(seriesLength - 1).keys()].map(() => ''),
            ]
          },
          borderWidth: 0,
          backgroundColor: 'var(--swi-bg-secondary)',
        },

        plotOptions: {
          series: {
            animation: false,
            dataLabels: {
              color: 'var(--swi-body-text-color-primary)',
            },
          },
        },
        navigator: {
          enabled: !this.hideNavigator,
          xAxis: {
            labels: {
              style: {
                color: 'var(--swi-body-text-color-primary)',
              },
            },
            lineColor: 'var(--color-silver-screen-1)',
            gridLineColor: 'var(--color-silver-screen-1)',
          },
          series: {
            color: 'var(--swi-bg-brand)',
            fillOpacity: 0,
            type: 'line',
          },
          outlineColor: 'var(--color-silver-screen-1)',
        },
      }
    },
  },
}
